import { Anchor, Breadcrumbs, Group, Text } from '@mantine/core';
import { useMatch } from 'react-router-dom';
import { Automation } from '@/types/automations.ts';
import useRetrieveRun from '@/hooks/api/runs/useRetrieveRun.ts';

type Props = {
  automation: Automation;
};

const HeaderBreadCrumbs = ({ automation }: Props) => {
  const isResultPage = !!useMatch('/automations/:automationId/results/:runId');

  const { data: run } = useRetrieveRun();

  return (
    <Group gap={'xs'} wrap={'nowrap'} style={{ minWidth: 0, maxWidth: '100%' }}>
      {/*<Link to={'/automations'}>*/}
      {/*  <Group*/}
      {/*    style={{*/}
      {/*      border: '1px solid #E6E6E6',*/}
      {/*      borderRadius: '8px',*/}
      {/*      boxShadow: 'rgb(0 0 0 / 4%) 0 1px 2px 0, rgb(0 0 0 / 4%) 0 2px 4px 0',*/}
      {/*    }}*/}
      {/*    w={'30px'}*/}
      {/*    h={'30px'}*/}
      {/*    align={'center'}*/}
      {/*    justify={'center'}*/}
      {/*  >*/}
      {/*    <Logo width={'21px'} height={'16.8px'} style={{}} />*/}
      {/*  </Group>*/}
      {/*</Link>*/}

      <Breadcrumbs
        separatorMargin="6px"
        separator={
          <Text c={'#757575'} size={'12px'} fw={500}>
            /
          </Text>
        }
        style={{ flexWrap: 'nowrap', minWidth: 0, maxWidth: '100%' }}
      >
        <Anchor href={'/automations'} key={'home'} c={'#757575'} size={'12px'} fw={500}>
          Home
        </Anchor>
        <Anchor
          href={'/automations/' + automation.id}
          key={'automation'}
          c={'#757575'}
          size={'12px'}
          fw={500}
          truncate={true}
        >
          {automation.name}
        </Anchor>
        {isResultPage && (
          <Text key={'automation'} c={'#757575'} size={'12px'} fw={500} truncate={true}>
            {run?.name}
          </Text>
        )}
      </Breadcrumbs>
    </Group>
  );
};

export default HeaderBreadCrumbs;
